import {useEffect, useState} from "react";
import { selectTreePc, navigationTreePC, urlPc, cleanMeans, ClassificationResource } from '../actions/proyects.actions';
import {alpha, makeStyles, withStyles} from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import {useHistory} from "react-router-dom";
import subprojectIcon from '../assets/img/icons/subproject.png';
import projectIcon from '../assets/img/icons/project.png';

import {useSelector, useDispatch} from "react-redux";

function MinusSquare(props) {
	return (
		<div className="d-flex">
			<ion-icon name="chevron-down-outline"></ion-icon>
			<img src={projectIcon} alt="icons" width="15" style={{ marginRight: 8}} {...props}/>
		</div>
	);
}

function PlusSquare(props) {
	return (
		<div className="d-flex">
			<ion-icon name="chevron-forward-outline"></ion-icon>
			<img src={projectIcon} alt="icons" width="15" style={{ marginRight: 8}} {...props}/>
			
		</div>
	);
}

function CloseSquare(props) {
	return (
		<img src={subprojectIcon} width="15" alt="icons" style={{ marginRight: 8}} {...props}/>
	);
}

const StyledTreeItem = withStyles((theme) => ({
	iconContainer: {
		"& .close": {
			opacity: 0.3,
		},
	},
	group: {
		marginLeft: 7,
		paddingLeft: 18,
		borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
	},
}))((props) => <TreeItem {...props} />);

const useStyles = makeStyles({
	root: {
		height: 264,
		flexGrow: 1,
		maxWidth: 400,
	},
});

const TreeCP = ({ idProject, codCla, type, data, urlPrefix }) => {
	// const codPCUrl = props.location.pathname.split('/')[4];
	
	let history = useHistory();
	const classes = useStyles();
	const dispatch = useDispatch();
	const [ levelStart ] = useState(1);
	const [ lastLevel ] = useState(5);
	const [loading, setLoading] = useState(false);

	const [refreshTree, setRefreshTree] = useState(null);
	const proyects = useSelector((state) => state.proyects);
	const [treeData, setTreeData] = useState([])
	const [search, setSearch] = useState();
	const [ itemSelected, setItemSelected ] = useState('')
	const [searchRegex, setSearchRegex] = useState()

	
	const converTreeArrayToMap = (treeArray) => {
		let orderedLevels = {};
		
		for (let i = 0; i < treeArray.length; i++) {
			const item = treeArray[i];
			if (item.Nivel >= levelStart) {
				if (!orderedLevels[item.Nivel]) {
					orderedLevels[item.Nivel] = [];
				}
				// if (item.Nivel > lastLevel) {
				// 	setLastLevel(item.Nivel);
				// }
				if (codCla && codCla.startsWith(item.CodClasificacion)) {
					dispatch(selectTreePc(item.CodClasificacion, true));
				}
				orderedLevels[item.Nivel].push({
					searchMatch: false,
					hidden: false,
					...item,
				});
			}
		}
	
		return orderedLevels;

	}

	
	const orderAllElements = (level = 1, parent = null, treeMap = null) => {
		if( (!treeMap || !treeMap[level]) ) {
			
			return null;
		};
		const nextLevel = level + 1;
		return treeMap[level]
				?.filter(
					(item) =>
						parent === null || item.PhantomParentId === parent.CodClasificacion
				)
				.map((filter) => {
					filter['breadcrumbs'] = level > 1 ? `${parent.breadcrumbs ? parent.breadcrumbs + ' / ' : '' }${filter.Descripcion}` : '';
					// filter['prevParents'] = parent ? [...parent.prevParents, filter.CodClasificacion] : [filter.CodClasificacion];
					filter.changeParent = parent 
						? () =>{ 
							filter.hidden = false;
							parent.changeParent();
							// TODO: aqui agregar para que se abra, en nuestro redux de selecteds
						} 
						: () => {
							filter.hidden = false;
						};
					if ( level === 1 || !search || search === '' ) {
						filter['hidden'] = false;
					} else {
						const descriptionLower = filter.Descripcion.toLowerCase();
						filter.searchMatch = new RegExp(search.toLowerCase()).test(descriptionLower) // descriptionLower.includes(search.toLowerCase());
						if (filter.searchMatch || (searchRegex !== '' && descriptionLower.match(searchRegex))) {
							
							filter.changeParent();
						} else if ( parent && parent.searchMatch ) {
							filter.hidden = false;
						} else {
							filter['hidden'] = true;
						}
					}
					filter['items'] = orderAllElements(nextLevel, filter, treeMap);
					return filter;
				});
	}

	useEffect(() => {
		setLoading(true);
		if ( search && search.includes(' ') ) {
			const myRegex = `(?=.*${search.toLowerCase().replaceAll(' ', ')(?=.*')})`;
			setSearchRegex(new RegExp(myRegex));
			setSearchRegex(myRegex);
		} else {
			setSearchRegex('');	
		}
		const treeMap = converTreeArrayToMap( data );
		const anyThing = orderAllElements(1, null, treeMap);
		setTreeData(anyThing);
		setLoading(false);
		// eslint-disable-next-line
	}, [loading, type, data, search]);
	
		
	const changeItem = (itemClassification, newTitle) => {
		
		if (itemSelected === itemClassification.CodClasificacion) return;
		setItemSelected(itemClassification.CodClasificacion);
		dispatch(navigationTreePC(newTitle))

		dispatch(ClassificationResource(idProject, type, itemClassification.CodClasificacion))
		

		history.push(`${urlPrefix}${itemClassification.CodClasificacion}`);
		
	}

	const drawerItems2 = (level, items) => {
		if ( !items ) return '';
		return items.map((item) => {
			if (level === lastLevel) {
				if (
					idProject &&
					refreshTree === null &&
					idProject ===
					item.CodClasificacion
				) {
					setRefreshTree(true);
					dispatch(
						navigationTreePC(
							`${item['breadcrumbs']}`
						)
					);
				}
				return (
					<StyledTreeItem  
						key={item.CodClasificacion}
						nodeId={item.CodClasificacion}
						label={item.Descripcion} 
						hidden={ item.hidden }
						className="seleted_tree"
						onLabelClick={( ) =>{ 
							dispatch(cleanMeans());
							dispatch(urlPc(`${urlPrefix}${item.CodClasificacion}`))
							changeItem(item, `${item.breadcrumbs}`)}
						}
					/>
				
				);
			} else {
				if (
					idProject &&
					refreshTree === null &&
					idProject ===
					item.CodClasificacion
				) {
					
					setRefreshTree(true);
					dispatch(
						navigationTreePC(
							`${item.breadcrumbs} / ${item.Descripcion}`
						)
					);
				}
				return (
					<StyledTreeItem
						key={`key-${item.CodClasificacion}.`}
						nodeId={item.CodClasificacion}
						label={item.Descripcion}
						hidden={ item.hidden }
						onIconClick={() => {
							// setRefreshTree([]);
							dispatch(selectTreePc(item.CodClasificacion));
						}}
						onLabelClick={ () => {
							changeItem(item, item['breadcrums'])
							dispatch(cleanMeans());
							dispatch(
								navigationTreePC(
									`${item.breadcrumbs}`
								)
							);
							dispatch(urlPc(`${urlPrefix}${item.CodClasificacion}`))
						}}
						
					>
						{ drawerItems2(( level + 1 ), item.items)}
					</StyledTreeItem>
				);
			}
		});
	}

	return (
		<>
			<div className="input-group mb-2">
				<div className="input-group-prepend">
					<div className="input-group-text" id="btnGroupAddon">
						<i className="fas fa-search"></i>
					</div>
				</div>
				<input
					type="search"
					className="form-control"
					placeholder="Buscador..."
					aria-label="Input group example"
					aria-describedby="btnGroupAddon"
					onChange={({target}) => setSearch(target.value)}
				/>
			</div>

			<TreeView
				className={classes.root}
				// defaultExpanded={["1"]}
				defaultCollapseIcon={<MinusSquare />}
				defaultExpandIcon={<PlusSquare />}
				defaultEndIcon={<CloseSquare />}
				expanded={proyects.treeSelectedsPc}
				selected={proyects.idPc}
				// className="mb-5"
			>
			
			{
				loading ? 'Cargando...' : 
				drawerItems2(1, treeData)
			}
			</TreeView>
		</>
	);
}

export default TreeCP
